import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { RolePermissionsService } from "../../services/role-permissions/role-permissions.service";

@Component({
  selector: "top-card-material",
  templateUrl: "./top-card-material.component.html",
  styleUrls: ["./top-card-material.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TopCardMaterialComponent implements OnInit {
  @Input() cardConfig: any;
  @Input() creation: boolean;
  @Input() duplication: boolean;
  @Input() current: any;
  @Input() icon: any;
  @Input() image: any;

  @Input() canDuplicate?: boolean = true;
  @Input() canNew?: boolean = true;
  @Input() canUpdate?: boolean = true;
  @Input() canRefresh?: boolean = true;
  @Input() canBack?: boolean = true;
  @Input() canMultipleSave?: boolean = false;
  @Input() multipleSaveOptions?: { primary: string; secondary: string[] };
  @Input() permissionResource: string;

  @Output() public backData: EventEmitter<any> = new EventEmitter();
  @Output() public refreshData: EventEmitter<any> = new EventEmitter();
  @Output() public duplicateData: EventEmitter<any> = new EventEmitter();
  @Output() public newData: EventEmitter<any> = new EventEmitter();
  @Output() public submitData: EventEmitter<any> = new EventEmitter();
  @Output() public submitDataFromMultiplePrimary: EventEmitter<any> = new EventEmitter();
  @Output() public submitDataFromMultipleSecondary: EventEmitter<any> = new EventEmitter();

  // Permissions
  public canWrite$: Observable<boolean> = of(true);

  constructor(private translate: TranslateService, public rolePermissionsService: RolePermissionsService) {}

    ngOnInit(): void {
    if (this.permissionResource) {
      this.canWrite$ = this.rolePermissionsService.hasPermission(
        this.permissionResource,
        "WRITE"
      );
    }
  }

  back() {
    this.backData.emit();
  }

  refresh() {
    this.refreshData.emit();
  }

  duplicate() {
    this.duplicateData.emit();
  }

  create() {
    this.newData.emit();
  }

  submit() {
    this.submitData.emit();
  }

  multipleOptionPrimarySubmited() {
    this.submitDataFromMultiplePrimary.emit();
  }

  multipleOptionSecondarySubmited(index: number) {
    this.submitDataFromMultipleSecondary.emit(index);
  }
}
